module.exports = __webpack_public_path__ + "img/Narrow Dark.abc50ef9.svg";